"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotStreakAbilityHandler = exports.HotStreakActorAbilityFactory = exports.HotStreakAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class HotStreakAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HotStreak;
        this.__typeName = "HotStreak";
    }
}
exports.HotStreakAbilityArgs = HotStreakAbilityArgs;
let HotStreakActorAbilityFactory = class HotStreakActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HotStreak", "Self", 0);
    }
};
HotStreakActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HotStreak")
], HotStreakActorAbilityFactory);
exports.HotStreakActorAbilityFactory = HotStreakActorAbilityFactory;
let HotStreakAbilityHandler = class HotStreakAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            supernatural: true,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Hot Streak", "Increases damage each hit", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, "Ability_HotStreak_OnAttack", {}))
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
HotStreakAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HotStreak)
], HotStreakAbilityHandler);
exports.HotStreakAbilityHandler = HotStreakAbilityHandler;
